translatedMessages = {
	aplicar: "Aplicar",
	cancelar: "Cancelar",
	desde: "Desde",
	hasta: "Hasta",
	custom: "Custom",
	do: "Do",
	lu: "Lu",
	ma: "Ma",
	mi: "Mi",
	ju: "Ju",
	vi: "Vi",
	sa: "Sa",
	enero: "Enero",
	febrero: "Febrero",
	marzo: "Marzo",
	abril: "Abril",
	mayo: "Mayo",
	junio: "Junio",
	julio: "Julio",
	agosto: "Agosto",
	septimbre: "Septimbre",
	octubre: "Octubre",
	novimbre: "Novimbre",
	decimbre: "Decimbre",
	seleccione: "Seleccione",
	reserva_de_dispositivo: "Reserva de dispositivo",
	bloqueo_de_dispositivo: "Bloqueo de dispositivo",
	agregado_de_dispositivo_a_propuesta: "Agregado de dispositivo a propuesta",
	agregado_de_dispositivo_a_pauta: "Agregado de dispositivo a pauta",
	detalle_de_reserva: "DETALLE DE RESERVA",
	motivo_de_bloque: "MOTIVO DE BLOQUEO",
	campo_requerido: "Campo requerido",
	la_fecha_de_expiracion_debe_ser_mayor_a_hoy:
		"La fecha de expiración debe ser mayor a hoy",
	la_fecha_de_inicio_no_puede_ser_menor_a_hoy:
		"La fecha de inicio no puede ser menor a hoy",
	la_fecha_de_inicio_no_puede_ser_mayor_a_la_fecha_de_fin:
		"La fecha de inicio no puede ser mayor a la fecha de fin",
	guardado: "Guardado",
	el_dispositivo_fue_agregado_con_exito:
		"El dispositivo fue agregado con éxito",
	descargar: "Descargar",
	listado_de_errores: "Listado de errores",
	soporte: "Soporte",
	soportes: "Soportes",
	detalle: "Detalles",
	los_datos_se_han_guardado_con_exito: "Los datos se han guardado con éxito",
	ha_ocurrido_un_error_al_guardar: "Ha ocurrido un error al guardar",
	arrastra_los_archivos_aqui_para_subirlos:
		"Arrastra los archivos aquí para subirlos",
	su_navegador_no_admite_la_carga_de_archivos_de_arrastrar_y_soltar:
		"Su navegador no admite la carga de archivos de arrastrar y soltar.",
	utilice_el_siguiente_formulario_de_respaldo_para_cargar_sus_archivos_como_en_los_viejos_tiempos:
		"Utilice el siguiente formulario de respaldo para cargar sus archivos como en los viejos tiempos.",
	el_archivo_es_demasiado_grande_filesize_tamano_maximo_de_archivo:
		"El archivo es demasiado grande ({{filesize}} MB). Tamaño máximo de archivo: {{maxFilesize}} MB.",
	no_puedes_subir_archivos_de_este_tipo:
		"No puedes subir archivos de este tipo.",
	el_servidor_respondio_con_el_codigo_statusCode:
		"El servidor respondió con el código {{statusCode}}.",
	cancelar_carga: "Cancelar carga",
	estas_seguro_de_que_deseas_cancelar_esta_carga:
		"¿Estás seguro de que deseas cancelar esta carga?",
	remover_archivo: "Remover archivo",
	no_puedes_subir_mas_archivos: "No puedes subir más archivos.",
	enero_: "enero",
	febrero_: "febrero",
	marzo_: "marzo",
	abril_: "abril",
	mayo_: "mayo",
	junio_: "junio",
	julio_: "julio",
	agosto_: "agosto",
	septiembre_: "septiembre",
	octubre_: "octubre",
	noviembre_: "noviembre",
	diciembre_: "diciembre",
	dispositivo: "Dispositivo",
	dispositivos: "Dispositivos",
	no_se_han_reservado_dispositivos: "No se han reservado dispositivos.",
	eliminado: "Eliminado",
	el_soporte_fue_eliminado_con_exito: "El soporte fue eliminado con éxito",
	soporte_eliminado: "Soporte Eliminado",
	el_soporte_se_elimino_correctamente: "El soporte se eliminó correctamente",
	el_dispositivo_fue_eliminado_con_exito:
		"El dispositivo fue eliminado con éxito",
	categorias_de_dispositivo: "CATEGORÍAS DE DISPOSITIVO",
	nombre_de_tipo_de_dispositivo: "NOMBRE DE TIPO DE DISPOSITIVO",
	ver_detalle: "Ver detalle",
	street_view_no_esta_disponible_antes_de_seleccionar_ubicacion_en_el_mapa:
		"Street View no está disponible antes de seleccionar ubicación en el mapa",
	street_view_no_esta_disponible_para_el_lugar_seleccionado:
		"Street View no está disponible para el lugar seleccionado",
	no_se_han_activado_campanas_aun_con_este_dispositivo:
		"No se han activado campañas aun con este dispositivo.",
	los_datos_fueron_eliminados_con_exito:
		"Los datos fueron eliminados con éxito",
	la_imagen_fue_subida_con_exito: "La imágen fue subida con éxito",
	la_imagen_fue_eliminada_con_exito: "La imágen fue eliminada con éxito",
	el_archivo_fue_eliminado_con_exito: "El archivo fue eliminado con éxito",
	los_datos_fueron_actualizados_con_exito:
		"Los datos fueron actualizados con éxito",
	ha_ocurrido_un_error_al_eliminar_el_elemento:
		"ha ocurrido un error al eliminar el elemento",
	no_hay_propuestas_creadas: "No hay propuestas creadas.",
	agencia_creada_con_exito: "Agencia creada con éxito",
	cuenta_creada_con_exito: "Cuenta creada con éxito",
	error: "Error",
	direccion: "Dirección",
	fecha_inicio: "Fecha inicio",
	fecha_fin: "Fecha fin",
	cantidad: "Cantidad",
	cuenta: "Cuenta",
	agencia: "Agencia",
	elementos_en_propuesta: "Elementos en propuesta",
	fecha_expiracion: "Fecha expiración",
	acciones: "Acciones",
	dar_de_baja: "Dar de baja",
	porciento_ocupacion: "% Ocupación",
	tooltip_porciento_ocupacion: "Ocupación: [bold]{valueY}[/]",
	la_fecha_de_expiracion_debe_ser_menor_o_igual_a_la_fecha_de_inicio:
		"La fecha de expiración debe ser menor o igual a la fecha de inicio",
	ha_excedido_la_maxima_cantidad_total_de_elementos:
		"Ha excedido la máxima cantidad de elementos.",
	enviar_aprobacion_de_propuesta: "Enviar aprobación de propuestas",
	enviar_cambios_en_propuesta: "Enviar cambios en propuesta",
	no_aplica: "No aplica",
	completar: "Completar",
	ayuda_soporte: "Ayuda? Soporte",
	no_hay_campannas_creadas: "No hay campañas creadas",
	disponible: "Disponible",
	no_disponible: "No disponible",
	la_fecha_inicio_mayor_expiracion:
		"La fecha de inicio tiene que ser mayor que la de expiración",
	la_fecha_fin_mayor_inicio:
		"La fecha de fin tiene que ser mayor o igual que la de inicio",
	datos_de_propuesta: "Datos de propuesta",
	datos_de_campana: "Datos de campaña",
	elementos_en_campana: "Elementos en campaña",
	listado_de_elementos_en_propuesta: "Listado de elementos en propuesta",
	listado_de_elementos_en_campana: "Listado de elementos en campaña",
	titulo: "Titulo",
	contacto: "Contacto",
	usuario_asignado: "Usuario asignado",
	tipo_gestion: "Tipo Gestión",
	cliente_prospect: "Cliente / Prospect",
	fecha: "Fecha",
	cliente: "Cliente",
	prospect: "Prospect",
	tipo_de_contacto: "Tipo de contacto",
	empresa: "Empresa",
	gestion: "Gestión",
	estado: "Estado",
	potencialidad: "Potencialidad",
	crear_contacto: "Crear contacto",
	guardar: "Guardar",
	nombre: "Nombres",
	nombre_: "Nombre",
	apellido: "Apellidos",
	asignado_a: "Asignado a",
	nombre_de_agencia: "Nombre de agencia",
	rubro: "Rubro",
	categoria: "Categoría",
	cargo: "Cargo",
	sub_rubro: "Sub rubro",
	email_empresa: "Email empresa",
	email: "Email",
	telefono_1: "Teléfono 1",
	telefono_2: "Teléfono 2",
	cumpleanios: "Cumpleaños",
	genero: "Género",
	estado_civil: "Estado civil",
	tiene_hijos: "Tiene hijos",
	origen_de_contacto: "Origen de contacto",
	url_sitio_web_de_la_empresa: "Url sitio web de la empresa",
	observaciones: "Observaciones",
	ingrese_observaciones: "Ingrese observaciones (opcional)",
	proveedor: "Proveedor",
	pais: "País",
	ciudad: "Ciudad",
	crear_gestion: "Crear gestión",
	no_hay_resultados: "No hay resultados",
	buscando: "Buscando...",
	para_buscar_ingrese_n_o_mas_caracteres:
		"Para buscar ingrese 3 o más caracteres",
	masculino: "Masculino",
	femenino: "Femenino",
	si: "Si",
	no: "No",
	nombre_de_cuenta: "Nombre de cuenta",
	nombre_de_provedor: "Nombre de provedor",
	potencialidad_del_negocio: "Potencialidad del negocio",
	ejecutivo: "Ejecutivo",
	date_format: "dd/mm/yyyy",
	datepicker: {
		days: [
			"Domingo",
			"Lunes",
			"Martes",
			"Miércoles",
			"Jueves",
			"Viernes",
			"Sábado",
			"Domingo",
		],
		daysShort: ["Dom", "Lun", "Mar", "Mié", "Jue", "Vie", "Sáb", "Dom"],
		daysMin: ["Do", "Lu", "Ma", "Mi", "Ju", "Vi", "Sa", "Do"],
		months: [
			"Enero",
			"Febrero",
			"Marzo",
			"Abril",
			"Mayo",
			"Junio",
			"Julio",
			"Agosto",
			"Septiembre",
			"Octubre",
			"Noviembre",
			"Diciembre",
		],
		monthsShort: [
			"Ene",
			"Feb",
			"Mar",
			"Abr",
			"May",
			"Jun",
			"Jul",
			"Ago",
			"Sep",
			"Oct",
			"Nov",
			"Dic",
		],
		today: "Hoy",
		format: "dd/mm/yyyy",
		titleFormat: "MM yyyy",
	},
	tipo_de_gestion_realizada: "Tipo de gestión realizada",
	titulo_de_la_gestion: "Titulo de la gestión",
	se_envio_obsequios: "Se envió obsequios",
	obsequio: "Obsequio",
	importe: "Importe",
	moneda: "Moneda",
	la_gestion_fue_guardada_con_exito: "La gestión fue guardada con éxito",
	eliminar_gestion: "Eliminar gestión",
	editar_gestion: "Editar gestión",
	eliminar: "Eliminar",
	esta_seguro_que_desea_eliminar_la_gestion_nombre_gestion:
		"¿Está seguro que desea eliminar la gestión (xxxxxx)?",
	faltan_datos_a_completar: "Faltan datos a completar",
	medidas_visibles_mayores_a_finales:
		"Las medidas visibles no pueden ser mayores a las finales",
	actualizado: "Actualizado",
	telefono: "Teléfono",
	esta_seguro_que_desea_eliminar_al_contacto:
		"Está seguro que desea eliminar al contacto (xxxxxx)",
	eliminar_contacto: "Eliminar contacto",
	gestiones: "Gestiones",
	listado_de_gestiones: "Listado de gestiones",
	buscar: "Buscar",
	todos: "Todos",
	ninguno: "Ninguno",
	fecha_de_creacion_del_gestion: "Fecha de creación del  gestión",
	logo: "Logo",
	tipo_de_empresa: "Tipo de empresa",
	eliminar_agencia: "Eliminar agencia",
	eliminar_cuenta: "Eliminar cuenta",
	eliminar_proveedor: "Eliminar proveedor",
	esta_seguro_que_desea_eliminar_la_empresa:
		"Esta seguro que desea eliminar la empresa (xxxxxx)",
	contactos: "Contactos",
	listado_de_contactos: "Listado de contactos",
	empresas: "Empresas",
	listado_de_empresas: "Listado de empresas",
	crear_agencia: "Crear agencia",
	crear_cuenta: "Crear cuenta",
	editar_agencia: "Editar agencia",
	crear_proveedor: "Crear proveedor",
	tipo_de_proveedor: "Tipo de proveedor",
	clasificacion: "Clasificación",
	sub_rublo: "Sub rublo",
	soltar_imagenes_para_cargar_click_aqui:
		"Soltar imágenes para cargar o click aquí",
	soltar_imagenes_o_cargar: "Arrastre o haga click aquí para adjuntar imagen",
	cargar_imagen: "Haga click aquí para adjuntar imagen",
	eliminar_logo: "Eliminar logo",
	editar_cuenta: "Editar cuenta",
	editar_proveedor: "Editar proveedor",
	nuevos_contactos: "Nuevos contactos",
	ultima_actualizacion: "Última actualización",
	gestion_realizada_a: "Gestión realizada a",
	los_datos_se_han_eliminado_con_exito: "Los datos se han eliminado con éxito",
	gestiones_historicas: "Gestiones históricas",
	gestiones_futuras: "Gestiones futuras",
	email_personal: "Email personal",
	validar: "Validar",
	realizo_una_gestion_con: "realizó una gestión con",
	gestion_realizada_por: "Gestión realizada por",
	no_hay_gestiones_realizadas: "No hay gestiones realizadas",
	proveedores: "Proveedores",
	total_obsequios: "Total obsequios",
	resumen_de_gestiones: "Resumen de gestiones",
	metricas_de_gestiones_comeriales: "Métricas de gestiones comerciales",
	gestiones_totales: "Gestiones totales",
	reunion_prom_semana: "Reunión prom. semana",
	propuestas_enviadas: "Propuestas enviadas",
	conversion_en_porcentaje: "Conversión en porcentaje",
	forma_de_contacto: "Forma de contacto",
	tipo_de_cliente: "Tipo de cliente",
	modulo: "Modulo",
	nombre_completo: "Nombre completo",
	mensaje: "Mensaje",
	enviar: "Enviar",
	ultimos_contactos_gestionados: "Últimos contactos gestionados",
	listado_de_contactos: "Listado de contactos",
	ultimas_cuentas_trabajadas: "ÚLTIMAS CUENTAS TRABAJADAS",
	ultimos_contactos_trabajados: "ÚLTIMOS CONTACTOS GESTIONADOS",
	proximas_gestiones: "PRÓXIMAS GESTIONES",
	gestiones_pendientes_confirmacion: "GESTIONES PENDIENTES DE CONFIRMACIÓN",
	gestiones_historicas: "GESTIONES HISTÓRICAS",
	confirmar: "CONFIRMAR",
	confirmar_: "Confirmar",
	editar: "Editar",
	no_cuentas_trabajadas: "No hay cuentas trabajadas",
	no_contactos_gestionados: "No hay contactos gestionados",
	no_informado: "No Informado",
	no_proximas_gestiones: "No hay próximas gestiones",
	no_gestiones_pendientes_confirmacion:
		"No hay gestiones pendientes de confirmación",
	no_gestiones_historicas: "No hay gestiones históricas",
	historial: "HISTORIAL",
	propuestas_pendientes_respuesta: "PROPUESTAS PENDIENTES DE RESPUESTA",
	proximas_campannas: "PRÓXIMAS CAMPAÑAS",
	no_hay_gestiones_futuras_cargadas: "No hay gestiones futuras cargadas",
	no_hay_gestiones_historicas_cargadas: "No hay gestiones históricas cargadas",
	realizado_por: "Realizado por",
	propuesta: "Propuesta",
	ver: "VER",
	campañas_realizadas: "Campañas realizadas",
	tasa_de_conversion: "Tasa de conversión",
	promedio_de_reuniones_semanales: "Promedio de reuniones semanales",
	gestiones_realizadas: "Gestiones realizadas",
	no_hay_propuestas_pendientes_de_respuesta:
		"No hay propuestas pendientes de respuesta",
	no_hay_proximas_campannas: "No hay próximas campañas",
	seguro_desea_confirmar_la_gestion:
		"¿Seguro desea confirmar la gestión (xxxxxx)?",
	confirmar_gestion: "Confirmar gestión",
	el_numero_de_telefono_es_incorrecto: "El número de teléfono es incorrecto",
	otro: "Otro",
	tipos_de_empresas: "Tipos de empresas",
	sin_contactos_asociados: "Sin contactos asociados",
	sin_gestiones_asociadas: "Sin gestiones asociadas",
	ultima_gestion: "Ultima gestión",
	no_hay_ultimos_contactos_gestionados: "No hay últimos contactos gestionados",
	no_hay_contactos: "No hay contactos",
	usuario: "Usuario",
	tipo_de_gestion: "Tipo de gestión",
	gestiones_por_usuario_top_15: "Gestiones por usuario (TOP 15)",
	montos_en_propuestas_generadas: "Montos en propuestas generadas",
	montos_en_campanas_ejecutadas: "Montos en campañas ejecutadas",
	evolucion_de_las_gestiones: "Evolución de las gestiones",
	gestiones_por_cuenta_top_20: "Gestiones por cuenta (top 20)",
	crear_empresa: "Crear empresa",
	campanas_generadas: "Campañas generadas",
	tasa_de_conversion: "Tasa de conversión",
	no_hay_empresas_creadas: "No hay empresas creadas",
	no_hay_sucursales_creadas: "No hay sucursales creadas",
	sucursales_titulo: "Listado de Sucursales",
	no_hay_agentes_creados: "No hay agentes creados",
	agentes_titulo: "Listado de agentes",
	editar_empresa: "Editar empresa",
	habilitar: "Habilitar",
	habilitar_agencia: "Habilitar agencia",
	habilitar_cuenta: "Habilitar cuenta",
	habilitar_proveedor: "Habilitar proveedor",
	deshabilitar_agencia: "Deshabilitar agencia",
	deshabilitar_cuenta: "Deshabilitar cuenta",
	deshabilitar_proveedor: "Deshabilitar proveedor",
	esta_seguro_que_desea_eliminar_sucursal:
		"¿Seguro desea eliminar la sucursal (xxxxxx)?",
	esta_seguro_que_desea_eliminar_agente:
		"¿Seguro desea eliminar el agente (xxxxxx)?",
	eliminar_sucursal: "Eliminar Sucursal",
	eliminar_agente: "Eliminar Agente",
	editar_agente: "Editar Agente",
	editar_sucursal: "Editar Sucursal",
	provincia: "Provincia",
	esta_seguro_que_desea_habilitar_la_empresa:
		"¿Seguro desea habilitar la empresa (xxxxxx)?",
	esta_seguro_que_desea_deshabilitar_la_empresa:
		"¿Seguro desea deshabilitar la empresa (xxxxxx)?",
	deshabilitar: "Deshabilitar",
	tipo_soporte_ya_existe:
		"Ya existe un tipo de soporte con el nombre seleccionado.",
	sin_asignar: "Sin Asignar",
	varios: "Varios",
	item: "ITEM",
	total: "TOTAL",
	motivo: "MOTIVO",
	asignados_total: "ASIGNADOS / TOTAL",
	ubicacion_tipo_dispositivo: "UBICACIÓN / TIPO DE DISPOSITIVO",
	la_campanna_no_tiene_dispositivos_asociados:
		"La campaña no tiene dispositivos asociados",
	asignar_motivo: "Asignar motivo",
	ver_motivos: "Ver motivos",
	ver_mapa: "Ver mapa",
	motivos: "Motivos",
	ingrese_nuevo_motivo: "Ingrese nuevo motivo",
	agregar_motivo: "Agregar Motivo",
	cant: "CANT.",
	ubicacion: "UBICACIÓN",
	tipo_de_soporte: "TIPO DE SOPORTE",
	tipo_de_soporte_: "Tipo de soporte",
	no_encontrado_resultados: "No se han encontrado resultados",
	valor: "Valor",
	agregar: "Agregar",
	eliminar_elementos: "Eliminar elementos",
	seguro_desea_eliminar_los_elementos: "¿Seguro desea eliminar los elementos?",
	fecha_inicio_fin: "FECHA INICIO ~ FECHA FIN",
	date_format_D_MMM_YYYY: "D-MMM-YYYY",
	eliminar_motivos: "Eliminar motivos",
	seguro_desea_eliminar_los_motivos: "Seguro desea eliminar los motivos?",
	motivo: "Motivo",
	cantidad_de_elementos: "Cantidad de elementos",
	buscar_direccion_o_patente: "Buscar dirección o patente",
	periodo: "Periodo",
	no_hay_datos_disponibles: "No hay datos disponibles",
	id: "ID",
	lleva_prueba_color: "LLEVA PRUEBA COLOR",
	tipo_de_dispositivo: "Tipo de dispositivo",
	color: "Color",
	agregar_editar_motivo: "AGREGAR / EDITAR MOTIVO",
	asignacion_de_motivos: "Asignación de motivos",
	tipos_de_soporte: "Tipos de soporte",
	hora_inicio: "Hora inicio",
	hora_fin: "Hora fin",
	dias: "Días",
	por_tipo_de_soporte: "POR TIPO DE SOPORTE",
	por_motivo: "POR MOTIVO",
	filtros: "Filtros",
	sin_motivo_asignado: "Sin Motivo Asignado",
	confirmar_campana: "Confirmar campaña",
	seguro_decea_confirmar_campana:
		"¿Seguro desea confirmar la campaña? No podrá volver a editar los elementos ni asignar motivos.",
	initial_of_weeksdays: ["L", "M", "X", "J", "V", "S", "D"],
	accion_eliminar: "Acción eliminar",
	seguro_que_desea_eliminar_duplicado_de_XXXX:
		"¿Seguro que desea eliminar duplicado de XXXX?",
	debe_selecciona_minimo_un_dia: "Debe seleccionar minimo un día",
	campanna: "Campaña",
	sustrato: "Sustrato",
	tecnologia: "Tecnología",
	fecha_de_inicio: "Fecha de inicio",
	medida_final: "Medida final",
	duracion_maxima: "Duración máxima",
	formato_digital: "Formato Digital",
	tiene_rotacion: "Tiene Rotación",
	medida_visible: "Medida visible",
	ver_dispositivo: "VER DISPOSITIVO",
	descargar_original: "DESCARGAR ORIGINAL",
	descargar_archivo_en_baja: "DESCARGAR ARCHIVO EN BAJA",
	no_hay_elementos_asociados: "No hay elementos asociados",
	no_hay_elementos_disponibles: "No hay elementos disponibles",
	jpg_en_baja: "Jpg en baja",
	video_en_baja: "Video en baja",
	arrastre_o_haga_click_aqui: "Arrastre o haga click aqui",
	descargar_ficha: "DESCARGAR FICHA",
	analogico: "Analógico",
	digital: "Digital",
	link_de_descarga: "Link de descarga",
	fecha_aprobacion_prueba_color: "Fecha aprobación prueba color",
	fecha_envio_imprenta: "Fecha envío imprenta",
	fecha_finalizacion_impresion: "Fecha finalización impresión",
	segundos: "Segundos",
	formato_de_imagen_no_valido: "Formato de image no válido",
	formato_de_video_no_valido: "Formato de video no válido",
	imprenta: "Imprenta",
	solo_admite_un_archivo_maximo: "Solo adminte un archivo máximo",
	solo_admite_archivos_jpg_jpeg_bmp_png_gif_tiff:
		"Solo admite archivos .jpg, .jpeg, .bmp, .png, .gif, .tiff",
	solo_admite_archivos_wma_mp4_avi_mov:
		"Solo admite archivos .wma, .mp4, .avi, .mov",
	el_archivo_excede_a_10_mb_en_su_tamano:
		"El archivo excede a 10 Mb en su tamaño",
	ha_ocurrido_un_error_al_descargar_el_archivo:
		"Ha ocurrido un error al descargar el archivo",
	poi: "POI",
	puntos_de_interes: "Puntos de interes",
	observacion_medidas: "Observaciones medidas",
	sub_categoria: "Sub categoría",
	disponibilidad: "Disponibilidad",
	ots: "Ots",
	date_range_picker_locale: {
		sunday: "Do",
		monday: "Lu",
		tuesday: "Ma",
		wednesday: "Mi",
		thursday: "Ju",
		friday: "Vi",
		saturday: "Sa",
		today: "Hoy",
		ok: "Aplicar",
	},
	referencias: "Referencias",
	no_se_han_agregado_soportes_a_la_propuesta:
		"No se han agregado soportes a la propuesta",
	editar_fechas: "Editar fechas",
	ver_comentarios: "Ver comentarios",
	seleccionados: "Seleccionados",
	medidas_comerciales_alto_x_ancho: "Medidas comerciales (alto x ancho)",
	quitar: "Quitar",
	eliminar_figura_seleccionada: "Eliminar figura seleccionada",
	eliminar_todas_las_figuras: "Eliminar todas las figuras",
	confirma_que_desea_borrar_el_dato: "¿Confirma que desea borrar el dato?",
	la_tarjeta_volvera_estado_correspondiente_borraran_todos_los_datos_ingresados_posteriormente:
		"La tarjeta volverá al estado correspondiente y se borrarán todos los datos ingresados posteriormente",
	se_modifico_dato_desea_guardar_mantener_tarjeta_en_estado_actual_guardar_mover_estado_correspondiente:
		"Se modificó un dato, ¿desea guardar y mantener la tarjeta en el estado actual o guardar y mover al estado correspondiente?",
	de_ser_necesario_se_borraran_los_datos_existentes_de_estados_posteriores:
		"De ser necesario se borrarán los datos existentes de estados posteriores.",
	max: "Max",
	min: "Min",
	el_valor_minimo_no_puede_ser_vacio: "El valor mínimo no puede ser vacío",
	el_valor_maximo_no_puede_ser_vacio: "El valor máximo no puede ser vacío",
	el_valor_minimo_no_puede_superar_al_valor_maximo:
		"El valor mínimo no puede superar al valor máximo",
	el_valor_minimo_no_puede_ser_menor_al_tope_minimo_existente:
		"El valor mínimo no puede ser menor al tope mínimo existente",
	el_valor_maximo_no_puede_ser_mayor_al_tope_maximo_existente:
		"El valor máximo no puede ser mayor al tope máximo existente",
	el_valor_minimo_no_puede_ser_mayor_al_tope_maximo_existente:
		"El valor mínimo no puede ser mayor al tope máximo existente",
	el_valor_maximo_no_puede_ser_menor_al_tope_minimo_existente:
		"El valor máximo no puede ser menor al tope mínimo existente",
	ocultar_todos: "Ocultar todos",
	mostrar_todos: "Mostrar todos",
	radio: "Radio",
	guardar_mantener: "Guardar & Mantener",
	guardar_mover: "Guardar & Mover",
	agregar_comentario: "Agregar comentario",
	debe_seleccionar_solo_uno_listado: "Debe seleccionar solo uno del listado",
	el_tipo_soporte_seleccionado_listado_corresponde_este:
		"El tipo de soporte seleccionado del listado no corresponde con este",
	enviar_propuesta: "Enviar propuesta",
	editar_propuesta: "Editar propuesta",
	liberar_propuesta: "Liberar propuesta",
	convertir_a_campana: "Convertir a campaña",
	estado_de_propuesta_actualizado: "Estado de propuesta actualizado",
	error_al_actualizar_propuesta: "Error al actualizar propuesta",
	desea_dar_de_baja_esta_propuesta: "¿Desea dar de baja esta propuesta?",
	desea_convertir_esta_propuesta_a_campaña:
		"¿Desea convertir ésta propuesta a campaña?",
	aprobacion_de_propuesta: "Aprobación de propuesta",
	ingresar_mensaje_opcional: "Ingresar mensaje (Opcional)",
	enviada: "Enviada",
	propuesta_enviada_correctamente: "Propuesta enviada correctamente",
	agregado: "Agregado",
	fecha_de_vencimiento_de_propuesta: "Fecha de vencimiento de propuesta",
	el_formato_no_es_correcto: "El formato no es correcto",
	este_campo_es_requerido: "Este campo es requerido",
	el_campo_no_puede_tener_mas_de_n_caracteres:
		"El campo no puede tener más de {###} caracteres.",
	la_fecha_de_vencimiento_debe_ser_posterior_o_igual_a_hoy:
		"La fecha de vencimiento debe ser posterior o igual a hoy.",
	quitar_elementos: "Quitar elementos",
	el_soporte_quitar_esta_mas_propuesta_desea_quitar_todas_sus_instancias_del_listado:
		"¿El elemento a eliminar está más de una vez en la propuesta, desea quitar todas sus instancias del listado?",
	confirma_que_desea_quitar_dispositivo_propuesta:
		"¿Confirma que desea eliminar el elemento de la propuesta?",
	editar_seleccionados: "Editar seleccionados",
	soportes_seleccionados: "Soportes seleccionados",
	debe_seleccionar_un_rango_de_fechas: "Debe seleccionar un rango de fechas",
	ha_ocurrido_un_error_al_actualizar_intentelo_mas_tarde:
		"Ha ocurrido un error al actualizar. Inténtelo más tarde",
	proposal_comments: "Comentarios",
	proposal_old_comments: "Comentarios anteriores",
	comment_view_more: "Ver comentario",
	comment_view_less: "Ocultar comentario",
	la_propuesta_contiene_al_menos_un_elemento_no_disponible:
		"La propuesta contiene al menos un elemento no dispoible",
	soportes_asignados: "Soportes asignados",
	datos_de_la_propuesta: "Datos de la propuesta",
	el_listado_del_tipo_soporte_esta_completo:
		"El listado del tipo de soporte está completo",
	seleccionar_soporte: "Selecciona soporte",
	direccion_o_patente: "Dirección o patente",
	checking_approve: "Aprobar",
	checking_reject: "Rechazar",
	soportes_no_disponibles: "Soportes no disponibles",
	revisar_disponibilidad: "Revisar disponibilidad",
	al_convertir_a_campana_se_descartaran_los_soportes_no_disponibles_estas_seguro:
		"Al convertir a campaña se descartarán los soportes no disponibles, ¿estas seguro?",
	si_descartar_no_disponibles: "Si, descartar no disponibles",
	no_editar_propuesta: "No, editar propuesta",
	checking_request_changes: "Solicitar cambios",
	checking_saved: "Guardado",
	saved_changes: "Cambios realizados con éxito",
	checking_strategy_tab: "Estrategia",
	checking_proposaList_tab: "Listado de elementos en propuesta",
	checking_map_tab: "Mapa de soportes",
	listado_de_elementos: "Listado de elementos",
	estrategia: "Estrategia",
	escribe_aqui: "Escribe aqui...",
	descartar: "Descartar",
	vista_previa: "Vista previa",
	No_se_admite_propuesta_sin_soportes: "No se admite propuesta sin soportes",
	checking_modal_accept: "Aceptar",
	checking_modal_cancel: "Cancelar",
	checking_modal_text: "¿Seguro que desea aprobar la propuesta?",
	existen_soportes_incompletos: "Existen soportes incompletos",
	listado_de_soportes: "Listado de soportes",
	tipo_dispositivo_ubicacion: "Tipo de dispositvo - Ubicación",
	solo_puede_subir_n_archivos_simultaneos:
		"Solo puede subir {n} archivos simultaneos",
};
